import type {Supplier} from '../../internals/repository/SupplierRepository';

/**
 * The figures for one row: the server's when it sent them, else derived from
 * the intakes in the store (a server that predates the computed columns).
 */
export function supplierFigures(
  s: Supplier,
  fallback?: {last?: string; total30d: number; count: number},
): {last: string | null; count: number; total30d: number} {
  if (s.intakeCount != null) {
    return {
      last: s.lastIntakeAt ?? null,
      count: s.intakeCount,
      total30d: Number(s.receivedTotal30d) || 0,
    };
  }
  return {last: fallback?.last ?? null, count: fallback?.count ?? 0, total30d: fallback?.total30d ?? 0};
}
